// extracted by mini-css-extract-plugin
export default {"root":"styles_root__3yHAK","border":"styles_border__YktMs","animation":"styles_animation__qk7Gc"};